<template>
  <div>
      <!-- Performances -->
      <div class="container-flavor">
        <h1 class="header-font-left" > Performances </h1> 
        <h3 class="header-font-left"> Upcoming </h3>
        <p class="paragraph-font-left indented-list">
           <!-- Edit below this line to add a new entry for an Upcoming Show -->
            ⟡ TBD ⟡
        </p>
        <h3 class="header-font-left"> Past </h3>
        <p class="paragraph-font-left indented-list">
          <!-- Edit below this line to add a new entry for a Past Show -->
             <strong> ⟡ 8/27/26 </strong> - Full Moon Concert at Lake Merritt, Oakland, CA <br>
             <strong> ⟡ Week of June 27th - July 4th </strong> - EEFC Balkan Camp, Mendocino, CA <br>
             <strong> ⟡ 5/30/26 </strong> - Third Annual Occidental World Music and Dance Festival, Occidental Center for the Arts, Occidental, CA <br>
             <strong> ⟡ 1/17/26 </strong> - Berkeley Balkan Bacchanal, Starry Plough Pub, Berkeley, CA <br>
             <strong> ⟡ 10/17/25 </strong> - Bakers and Commons, Berkeley, CA <br>
             <strong> ⟡ 9/5/25 </strong> - Selkie Fest, Fremont, CA <br>
             <strong> ⟡ 7/19/25 </strong> - Berkeley Balkan Bacchanal, Starry Plough Pub, Berkeley, CA <br>
             <strong> ⟡ 7/2/25 </strong> - EEFC Balkan Camp, Mendocino, CA <br>
             <strong> ⟡ 6/7/25 </strong> - Second Annual Occidental World Music and Dance Festival, Occidental Center for the Arts, Occidental, CA <br>
             <strong> ⟡ 1/18/25 </strong> - Berkeley Balkan Bacchanal, Starry Plough Pub, Berkeley, CA <br>
             <strong> ⟡ 12/31/24 </strong> - Balkan New Year’s Eve, Ashkenaz, Berkeley, CA <br>
             <strong> ⟡ 11/22/24 </strong> - The Lost Church, San Francisco, CA <br>
             <strong> ⟡ 7/20/24 </strong> - Berkeley Balkan Bacchanal, Ashkenaz, Berkeley, CA <br>
             <strong> ⟡ 5/19/24 </strong> - Balkan Sundays, Bissap Baobab, San Francisco, CA <br>
             <strong> ⟡ 3/16/24 </strong> - Berkeley Balkan Bacchanal, Starry Plough Pub, Berkeley, CA <br>
        </p>
    </div>
  </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');

.header-font-center {
  color: #FFCD86;
  text-align: center;
  padding-top: 15px;
  padding-bottom: 10px;
}
.header-font-right {
    color: #FFCD86;
  text-align: right;
}
.header-font-left{ 
  color: #FFCD86;
  text-align: left;
}
.paragraph-font-center {
  color: #F6A45E;
  text-align: center;
  font-size:large;
}
.paragraph-font-right {
  color: #F6A45E;
  text-align: right;
  font-size: large;
}
.paragraph-font-left{ 
  color: #F6A45E;
  text-align: left;
  font-size: large;
}
.container-flavor {
  padding: 50px 5% 50px;
  background-color: #181F2A;
}
.indented-list {
  margin-left: 50px;
  background-color: #181F2A;
  line-height: 2;
}
.link-colors {
  color: #FFCD86;
  display: inline;
  width: 100%;
}
.icon-link-container {
  width: 45px;
  justify-content: center;
  display: inline-flex;
  align-items: center;
}
img {
  height: auto;
  display: block;
}
</style>

